import {
  GET_CATEGORY_PLANS,
  CREATE_CATEGORY_PLANS,
  DELETE_CATEGORY_PLANS,
  UPDATE_CATEGORY_PLANS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  RESET_CATEGORY_PLANS,
} from './actionType';

// common success
export const CategoryPlansApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const CategoryPlansApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const CategoryPlans = () => ({
  type: GET_CATEGORY_PLANS,
});

export const CreateCategoryPlans = (data) => ({
  type: CREATE_CATEGORY_PLANS,
  payload: { data },
});

export const UpdateCategoryPlans = (data) => ({
  type: UPDATE_CATEGORY_PLANS,
  payload: { data },
});

export const DeleteCategoryPlans = (id) => ({
  type: DELETE_CATEGORY_PLANS,
  payload: { id },
});

export const ResetCategoryPlans = () => ({
  type: RESET_CATEGORY_PLANS,
});
